import AsgkApi, {loyaltyTypeDto, PositionDto, User} from "./models/asgkApi";
import React, {useEffect, useMemo, useState} from "react";
import RegLink from "./components/RegLink";
import BonusCard from "./components/BonusCard";
import {AxiosError} from "axios";

export default function DiscountPage(props: { form: HTMLFormElement }) {
  const [phone, setPhone] = useState('');
  const [link, setLink] = useState('');
  const [tg_link, setTgLink] = useState('');
  const [user, setUser] = useState<User>();
  const [operation, setOperation] = useState<loyaltyTypeDto>();
  const [correctPaymentSystem, setCorrectPaymentSystem] = useState(false);
  const [observer, setObserver] = useState<MutationObserver>();
  const [deliveryObserver, setDeliveryObserver] = useState<MutationObserver>();
  const [deliveryServicesList, setDeliveryServicesList] = useState<string[]>([]);
  const [isPhoneInputVisible, setIsPhoneInputVisible] = useState(true); // состояние для отслеживания видимости отображения поля телефона

  const asgk: AsgkApi = useMemo((): AsgkApi => new AsgkApi('Test'), []);

  useEffect(() => {
    const checkPhoneInputVisibility = (): void => {
      const phoneInputGroup: Element | null = document.querySelector('.t-input-group.t-input-group_ph');
      if (phoneInputGroup) {
        const isVisible: boolean = window.getComputedStyle(phoneInputGroup).display !== 'none';
        setIsPhoneInputVisible(isVisible);
      }
    };

    // Проверяем сразу при монтировании
    checkPhoneInputVisibility();

    // Создаем наблюдатель для отслеживания изменений в DOM
    const visibilityObserver = new MutationObserver(checkPhoneInputVisibility);

    // Начинаем наблюдение за изменениями атрибутов и структуры
    if (document.body) {
      visibilityObserver.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['style', 'class']
      });
    }

    return (): void => {
      visibilityObserver.disconnect();
    };
  }, []);

  useEffect((): void => {
    const payments: HTMLCollectionOf<Element> = document.getElementsByClassName('t-radio_payment');

    Array.prototype.forEach.call(payments, function (payment): void {
      if (payment.value === 'custom' && payment.checked === true) {
        setCorrectPaymentSystem(true);

        // КОСТЫЛЬ
        // при повторном открытии корзины наш блок итогов заменяется тильдовскими итогами
        // добавили перетыкивание способа оплаты - теперь тильдовские итоги заменяются нашими итогами
        const payments: HTMLCollectionOf<Element> = document.getElementsByClassName('t-radio_payment');

        (payments[0] as HTMLElement).click();

        Array.prototype.forEach.call(payments, function (payment): void {
          if (payment.value === 'custom') {
            (payment as HTMLElement).click();
          }
        });
        // КОСТЫЛЬ
      }

      payment.addEventListener('click', function (e: { target: { value: string; }; }): void {
        if (e.target.value === 'custom') {
          setCorrectPaymentSystem(true);
        } else {
          setCorrectPaymentSystem(false);
        }
      })
    });
  }, [])

  useEffect((): void => {
    const phone_classes: string = '.' + window?.TildaPlugin?.phone_classes!.replaceAll(' ', '.');
    let phoneElement: HTMLInputElement = Array.from(props.form.querySelectorAll(phone_classes))
      .find((item: Element): boolean => (item as HTMLInputElement).type === 'tel')! as HTMLInputElement;

    setTimeout((): void => {
      if (phoneElement.value) {
        setPhone(phoneElement.value.replace(/[^0-9]/g, ''));

        getSearch(true);
      }
    }, 100);

    // для заполнения с нуля
    const setPhoneFunction = (e: any): void => {
      setPhone(e.target.value.replace(/[^0-9]/g, "") ?? '');
    }

    phoneElement.addEventListener('change', setPhoneFunction);

    // const siblingPhoneElement: HTMLInputElement = phoneElement.nextElementSibling as HTMLInputElement;
    // console.log('siblingPhoneElement ', siblingPhoneElement);
    //
    // // для кейсов автоподставления
    // if (siblingPhoneElement?.tagName === 'INPUT') {
    //     // для мобилки, там при автоподставлении value сразу есть
    //     if (siblingPhoneElement?.value) {
    //         console.log('siblingPhoneElement.value ', siblingPhoneElement.value);
    //         setPhone(siblingPhoneElement.value.replace(/[^0-9]/g, ''));
    //     }
    //
    //     // для компа, при подставлении value пустует, поэтому подписываемся на изменение атрибута value через mutation
    //     const handleValue = () => {
    //         const val = (siblingPhoneElement?.value ?? '').replace(/[^0-9]/g, '');
    //         setPhone(val);
    //     };
    //
    //     const observer = new MutationObserver(() => {
    //         handleValue();
    //     });
    //
    //     if (siblingPhoneElement) {
    //         observer.observe(siblingPhoneElement, {
    //             attributes: true,
    //             attributeFilter: ['value'],
    //         });
    //     }
    // } else {
    //
    // }
  }, [])

  useEffect(() => {
    let lastPhoneValue: string = '';

    const checkPhoneChanges = (): void => {
      const phone_classes: string = '.' + window?.TildaPlugin?.phone_classes!.replaceAll(' ', '.');
      const phoneElement = Array.from(props.form.querySelectorAll(phone_classes))
        .find(item => (item as HTMLInputElement).type === 'tel') as HTMLInputElement;

      if (phoneElement && phoneElement.value) {
        const currentPhone: string = phoneElement.value.replace(/[^0-9]/g, '');

        if (currentPhone !== lastPhoneValue && currentPhone.length > 9) {
          lastPhoneValue = currentPhone;
          setPhone(currentPhone);
          getSearch(true);
        }
      }
    };

    const interval = setInterval(checkPhoneChanges, 250);

    return (): void => {
      clearInterval(interval);
    };
  }, [props.form]);

  useEffect((): void => {
    if (deliveryObserver) {
      deliveryObserver.disconnect();
    }

    const deliveryWrapDiv: HTMLDivElement = document.getElementsByClassName('t-radio__wrapper-delivery')[0] as HTMLDivElement;

    if (deliveryWrapDiv) {
      // получение списка названий сервисов доставки сразу при открытии
      // у sakishi-rolls например список статический и мутации не происходит, поэтому вынесено наружу
      getDeliveryServicesList(deliveryWrapDiv);

      // получение списка названий сервисов доставки после мутации-получения списка сервисов доставок
      const observer = new MutationObserver(function (mutations: MutationRecord[]): void {
        mutations.forEach((): void => {
          getDeliveryServicesList(deliveryWrapDiv);
        });
      });

      const config: MutationObserverInit = {childList: true, subtree: true};
      observer.observe(deliveryWrapDiv, config);
      setDeliveryObserver(deliveryObserver);
    }
  }, []);

  useEffect((): void => {
    const loadData = async (): Promise<void> => {
      if (!user) {
        const {link, tg_link} = await asgk.cardDeliveryForm();
        setLink(link);
        setTgLink(tg_link);
      }
    }

    loadData().then()
  }, [asgk, user])

  useEffect(() => {
    // кейс когда клиент уже вводил телефон и выбирал способ оплаты лоялкой, тогда уходит и searchuser и operation
    if (correctPaymentSystem) {
      getSearch(true);
    } else {
      // кейс когда клиент в первый раз вводит номер телефона, способ оплаты еще не выбирал. В этом случае может
      // получиться лишний searchuser, если способ оплаты будет не лоялка, но зато не будет уходить operation
      getSearch(false);
    }
  }, [phone, asgk]);

  useEffect(() => {
    checkAllowedBonuses(user);
  }, [correctPaymentSystem])

  useEffect(() => {
    if (observer) {
      observer.disconnect();
    }

    //@ts-ignore
    const totalAmountWrapDiv: HTMLDivElement = document.querySelectorAll(".t706__cartwin-totalamount-wrap:not(.teyca)")[0];
    if (totalAmountWrapDiv && totalAmountWrapDiv.style.display === 'none') {
      totalAmountWrapDiv.style.display = 'block';
    }
    if (totalAmountWrapDiv !== undefined) {
      const totalAmountDiv = totalAmountWrapDiv.getElementsByClassName('t706__cartwin-totalamount')[0]
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(() => {
          checkAllowedBonuses(user)
        });
      });

      const config: MutationObserverInit = {childList: true, subtree: true};
      if (totalAmountDiv.childNodes.length) {
        observer.observe(totalAmountDiv, config);
      }
      setObserver(observer);
    }

  }, [user])

  function getDeliveryServicesList(deliveryWrapDiv: HTMLDivElement) {
    let deliveryBlock = document.getElementById("delivery-services-wrapper") as HTMLElement;
    const deliveryList: string[] = [];
    let deliveryServiceElements!: HTMLCollectionOf<any>;

    // у sakishi-rolls нет deliveryBlock, все сервисы доставки в deliveryWrapDiv
    if (deliveryBlock) {
      deliveryServiceElements = deliveryBlock.getElementsByClassName('delivery-checkbox-label');
    } else {
      deliveryServiceElements = deliveryWrapDiv.getElementsByTagName('label');
    }

    Array.prototype.forEach.call(deliveryServiceElements, function (deliveryService) {
      deliveryList.push(deliveryService.textContent!.trim().replaceAll('\n', ''));
    });
    setDeliveryServicesList(deliveryList);
  }

  function getSearch(sendOperation: boolean) {
    const loadData: () => Promise<void> = async (): Promise<void> => {
      if (phone.length > 9) {
        await asgk.searchUsers(phone)
          .then(users => {
            if (users.status === 200 && users.user.length > 0) {
              users.user.forEach((user: User): void => {
                if (user.phone.substr(user.phone.length - 10) === phone.substr(phone.length - 10)) {
                  setUser(user);
                  sendOperation && checkAllowedBonuses(user);
                }
              })
            }
          })
          .catch(err => {
            console.error(err.response.data);
            setUser(undefined);
          })
      } else {
        setUser(undefined);
      }
    };

    loadData().then();
  }

  async function checkAllowedBonuses(user?: User): Promise<void> {
    if (!user || !correctPaymentSystem) return;

    let summ: number = 0;
    let summ_without_discount: number = 0;
    const products: PositionDto[] = [];
    let delivery_cost: number = 0;

    // summ
    if (props.form !== undefined) {
      try {
        const blocks: NodeListOf<Element> = props.form.querySelectorAll(".t706__cartwin-totalamount-wrap:not(.teyca)");

        blocks.forEach((block: Element): void => {
          const priceWrapper: Element | null = block.querySelector(".t706__cartwin-totalamount");

          if (priceWrapper) {
            const priceElem: Element | null = priceWrapper.querySelector(".t706__cartwin-prodamount-price");

            if (priceElem) {
              summ = Number(priceElem.textContent?.trim().replace(' ', '').replace(',', '.')); // Сохраняем значение
            }
          }
        });
      } catch (e) {
      }
    }

    if (summ === 0) {
      try {
        const blocks: NodeListOf<Element> = document.querySelectorAll(".t706__cartwin-totalamount-wrap:not(.teyca)");

        blocks.forEach((block: Element): void => {
          const priceWrapper: Element | null = block.querySelector(".t706__cartwin-totalamount");

          if (priceWrapper) {
            const priceElem: Element | null = priceWrapper.querySelector(".t706__cartwin-prodamount-price");

            if (priceElem) {
              summ = Number(priceElem.textContent?.trim().replace(' ', '').replace(',', '.')); // Сохраняем значение
            }
          }
        });
      } catch (e) {
      }
    }

    // summ_without_discount уходит на бэк, но никак не используется в расчетах
    try {
      summ_without_discount = Number(document
        .getElementsByClassName('t706__cartwin-bottom')[0]
        .getElementsByClassName('t706__cartwin-prodamount-price')[0]
        .textContent?.replace(' ', '').replace(',', '.'));
    } catch (e) {
    }

    if (summ_without_discount === 0) {
      try {
        summ_without_discount = Number(document
          .getElementsByClassName('t706__cartwin-totalamount-info_value')[0]
          .getElementsByClassName('t706__cartwin-prodamount-price')[0]
          .textContent?.replace(' ', '').replace(',', '.'));
      } catch (e) {
      }
    }

    if (summ_without_discount === 0) {
      try {
        summ_without_discount = Number(document
          .getElementsByClassName('t706__cartwin-totalamount')[0]
          .getElementsByClassName('t706__cartwin-prodamount-price')[0]
          .textContent?.replace(' ', '').replace(',', '.'));
      } catch (e) {
      }
    }

    if (summ === 0 && summ_without_discount === 0) {
      setTimeout(() => {
        checkAllowedBonuses(user);
      }, 1000)
      return;
    }

    // products
    try {
      const productsDiv: Element = document
        .getElementsByClassName('t706__cartwin-products')[0];
      if (productsDiv) {
        // @ts-ignore
        productsDiv.childNodes.forEach((product: Element): void => {
          let newProduct: PositionDto = {
            name: '',
            price: 0,
            quantity: 0
          }
          newProduct.name = product.getElementsByClassName('t706__product-title')[0].getElementsByTagName('a')[0].innerHTML ?? '';

          const prices = product.getElementsByClassName('t706__cartwin-prodamount-price');
          newProduct.price = Number(prices[prices.length - 1].innerHTML.replace(' ', '').replace(',', '.')) ?? 0;

          newProduct.quantity = Number(product.getElementsByClassName('t706__product-quantity')[0].innerHTML) ?? 0;
          products.push(newProduct);
        })
      }
    } catch (e) {
    }

    if (products.length === 0) {
      try {
        const productsDiv: Element = document.getElementsByClassName('t706__cartpage-products')[0];

        if (productsDiv) {
          // @ts-ignore
          productsDiv.childNodes.forEach((product: Element): void => {
            let newProduct: PositionDto = {
              name: '',
              price: 0,
              quantity: 0
            }
            newProduct.name = product.getElementsByClassName('t706__product-title')[0].getElementsByTagName('a')[0].innerHTML ?? '';

            const prices = product.getElementsByClassName('t706__cartwin-prodamount-price');
            newProduct.price = Number(prices[prices.length - 1].innerHTML.replace(' ', '').replace(',', '.')) ?? 0;

            newProduct.quantity = Number(product.getElementsByClassName('t706__product-quantity')[0].innerHTML) ?? 0;
            products.push(newProduct);
          })
        }
      } catch (e) {
      }
    }

    // delivery_cost
    if (props.form !== undefined) {
      try {
        let blocks: NodeListOf<Element> = props.form.querySelectorAll(".t706__cartwin-totalamount-wrap:not(.teyca)");

        if (!blocks || !blocks.length) {
          blocks = document.querySelectorAll(".t706__cartwin-totalamount-wrap:not(.teyca)");
        }

        blocks.forEach((block: Element): void => {
          const deliveryWrapper: Element | null = block.querySelector(".t706__cartwin-totalamount-info");

          const labels: NodeListOf<Element> | undefined = deliveryWrapper?.querySelectorAll(".t706__cartwin-totalamount-info_label");

          labels?.forEach((label: Element): void => {
            if (label && deliveryServicesList.includes(label.textContent?.replace(':', '')!)) {
              const deliveryWrapper: HTMLSpanElement = label.nextElementSibling as HTMLSpanElement;

              if (deliveryWrapper && deliveryWrapper.className === 't706__cartwin-totalamount-info_value') {
                const priceElem: Element | null = deliveryWrapper.querySelector(".t706__cartwin-prodamount-price");

                if (priceElem) {
                  delivery_cost = parseFloat(priceElem.textContent?.trim().replace(' ', '').replace(',', '.') || '0');
                }
              }
            }
          });
        });
      } catch (e) {
      }
    }

    try {
      if (summ_without_discount > 0) {
        const operation: loyaltyTypeDto = await asgk.operation({
          user_id: user.user_id,
          cashier: "online",
          operation_number: Date.now().toString(),
          positions: products,
          summ,
          summ_without_discount,
          delivery_cost
        });

        setOperation(operation);
        setUser(operation.user);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw error
      } else if (error instanceof AxiosError) {
        if (!error && error['response'])
          console.error(error['response']['data']);
      }
    }
  }

  return <div>
    {correctPaymentSystem && isPhoneInputVisible && (
      <div className="t706__cartwin-top">
        <div className="t706__cartwin-heading t-name t-name_xl">Программа лояльности</div>
      </div>
    )}
    {
      user && props.form && isPhoneInputVisible
        ? <BonusCard
          correctPaymentSystem={correctPaymentSystem}
          user={user}
          form={props.form}
          asgk={asgk}
          setUser={setUser}
          observer={observer}
          setObserver={setObserver}
          operation={operation}
        />
        : (correctPaymentSystem && isPhoneInputVisible ? <RegLink link={link} tg_link={tg_link}/> : <div/>)
    }
  </div>;
}
